import React                             from 'react';
import { Observe, defaultEquals }        from 'rewire-core';
import { ICell }                         from 'rewire-grid';
import { withStyles, Theme }             from 'rewire-ui';
import { isMultiple }                    from '../DataTypes';
import { StyleType }                     from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    paddingLeft: '2px',
  },
  before: {
    textDecoration: 'line-through',
    lineHeight: '1.5rem',
    color: theme.palette.error.main,
  },
  after: {
    lineHeight: '1.5rem',
    color: theme.palette.success.light,
  }
});

const arrayStyles = (theme: Theme) => ({
  ...styles(theme),
});

interface ICellProps {
  cell: ICell;
  classes: StyleType<typeof styles>;
}

export const AuditLogDifferenceCellStringArrayRenderer: React.FunctionComponent<ICellProps> = React.memo(withStyles(arrayStyles, (props) => {
  return <Observe render={() => {
    const { cell, classes } = props;
    if (!cell.value) return null;
    const value            = cell.column.map ? cell.column.map(cell.value) : cell.value;
    const {value1, value2} = value;
    const beforeDiff       = [] as string[];
    const afterDiff        = [] as string[];
    const intersection     = [] as string[];
    for (const v of value1 || []) {
      if (value2?.includes(v)) {
        intersection.push(v);
      } else {
        beforeDiff.push(v);
      }
    }
    for (const v of value2 || []) {
      if (!value1?.includes(v)) {
        afterDiff.push(v);
      }
    }

    return (
      <div className={classes.root}>
        {beforeDiff.map((bd: any, idx: number) => <div key={`beforeDiff-${idx.toString()}`} className={classes.before}>{bd}</div>)}
        {afterDiff.map((ad: any, idx: number) => <div key={`afterDiff-${idx.toString()}`} className={classes.after}>{ad}</div>)}
        {intersection.map((i: any, idx: number) => <div key={`intersection-${idx.toString()}`}>{i}</div>)}
      </div>
    );
  }} />;
}));

const AuditLogDifferenceCellRenderer: React.FunctionComponent<ICellProps> = React.memo(withStyles(styles, (props) => {
  return <Observe render={() => {
    const { cell, classes } = props;
    if (!cell.value) return null;
    const value            = cell.column.map ? cell.column.map(cell.value) : cell.value;
    const {value1, value2} = value;
    return (
      (isMultiple(cell.value.value1) && isMultiple(cell.value.value2)) || defaultEquals(cell.value.value1, cell.value.value2)
        ? <span>{value1}</span>
        : <>
            <div className={classes.before}>{value1}</div>
            <div className={classes.after}>{value2}</div>
          </>
    );
  }} />;
}));

export default AuditLogDifferenceCellRenderer;
